import { combineReducers } from "redux";
import vendorexperts from "../features/admin/vendor_expert/Slice";

const vendor_expert = combineReducers({
  vendorexperts: vendorexperts,
});

export default vendor_expert;
